/**
 * Build Recharts data for dashboard "Shipment Paid vs Balance" line chart.
 * Uses server-side time buckets (day / week / month) from chart_trend API field.
 */
export function buildDashboardChartData(chartTrend) {
  const points = chartTrend?.points || [];
  const bucket = chartTrend?.bucket || 'month';

  return points.map((point) => ({
    ...point,
    name: formatChartPeriodLabel(point.period, bucket),
    paid: Number(point.paid) || 0,
    balance: Number(point.balance) || 0,
    unpaid: Number(point.unpaid) || 0,
    returned: Number(point.returned) || 0,
    missing: Number(point.missing) || 0,
    returned_commission: Number(point.returned_commission) || 0,
    missing_commission: Number(point.missing_commission) || 0,
    records: Number(point.records) || 0,
    hours: Number(point.hours) || 0,
  }));
}

function formatChartPeriodLabel(period, bucket) {
  if (!period) return '';

  const [year, month, day] = period.split('-').map(Number);
  const date = new Date(year, month - 1, day || 1);

  if (bucket === 'day') {
    return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
  }

  if (bucket === 'week') {
    return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
  }

  return date.toLocaleDateString('en-IN', { month: 'short', year: 'numeric' });
}
